// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IDriverAlertToggleRequest {
	triggerId: string | undefined;

	enabled: boolean;

	$type?: string | undefined;
}
export class DriverAlertToggleRequest {
	constructor(data?: IDriverAlertToggleRequest) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	triggerId: string | undefined;

	enabled: boolean = false;

	static $type: string = "CoreApi.Models.DriverAlertToggleRequest, ";
	$type?: string | undefined = DriverAlertToggleRequest.$type;
}

